import { render } from "./TeamsView.vue?vue&type=template&id=09bca2fa&scoped=true"
import script from "./TeamsView.vue?vue&type=script&lang=js"
export * from "./TeamsView.vue?vue&type=script&lang=js"

import "./TeamsView.vue?vue&type=style&index=0&id=09bca2fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bca2fa"]])

export default __exports__